module.exports = __webpack_public_path__ + "static/media/june-2022.78784ee2.svg";